// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__dnYmh","head":"ProcedureTableInfo_head__3Ocku"};